import React from 'react';
import GameModal from '../../GameModal/GameModal.tsx';
import SubtextWordsList from '../../shared/SubtextWordsList.tsx';
import { GameType } from '../../../types/GameType.ts';
import { getGameConfig, SubtextGameConfig } from '../../../types/GameConfig.ts';
import './YesterdayModal.css';

interface SubtextYesterdayModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SubtextYesterdayModal({ isOpen, onClose }: SubtextYesterdayModalProps) {
  const gameConfig = getGameConfig(GameType.SUBTEXT) as SubtextGameConfig;
  const currentGameNumber = gameConfig.getCurrentGameNumber();
  const yesterdayGameNumber = currentGameNumber - 1;
  const yesterdayGameData = yesterdayGameNumber >= 1 ? gameConfig.getGameData(yesterdayGameNumber) : null;
  const yesterdayWord = yesterdayGameData?.word || null;
  const yesterdayValidSubWords = yesterdayGameData?.validSubWords || [];

  const modalContent = (
    <div className="subtext-yesterday-modal-content">
      {yesterdayWord && (
        <div className="subtextYesterdayWordDisplay">
          <strong>{yesterdayWord.toUpperCase()}</strong>
        </div>
      )}
      <div className="subtextWordsListWrapper">
        {yesterdayValidSubWords.length > 0 ? (
          <SubtextWordsList 
            words={yesterdayValidSubWords} 
            longestSubWordLength={yesterdayGameData?.longestSubWordLength}
          />
        ) : (
          <div className="subtextNoWordsMessage">
            No words available for yesterday's game.
          </div>
        )}
      </div>
    </div>
  );
  
  return (
    <GameModal
      title="Yesterday"
      content={modalContent}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
} 